/** Public URLs for standard / front-door promo landing hero images (files live under public/images/FrontDoor). */
export const PROMO_LANDING_DESKTOP_IMAGE = "/images/FrontDoor/frontdoor-desktop-landing.png"
export const PROMO_LANDING_MOBILE_IMAGE = "/images/FrontDoor/frontdoor-mobile-landing.png"

const DESKTOP_MEDIA_QUERY = "(min-width: 768px)"

export const getPromoLandingImage = () => {
  const isDesktop = typeof window !== "undefined" && window.matchMedia?.(DESKTOP_MEDIA_QUERY).matches
  return isDesktop ? PROMO_LANDING_DESKTOP_IMAGE : PROMO_LANDING_MOBILE_IMAGE
}
